import { useMutation, useQueryClient } from '@tanstack/react-query';

import { authApi } from '../auth.api';
import { useAuthStore } from '../auth.store';
import type { BiometriaPayload, LoginBiometriaResponse } from '../types';

/**
 * Inicia sesión con la cara.
 *
 * Publica la sesión igual que el login con contraseña (`setSession`), para que el resto de la
 * aplicación no distinga cómo se entró. Devuelve también la distancia calculada, útil para calibrar
 * el umbral con caras reales.
 */
export function useLoginBiometria() {
  const queryClient = useQueryClient();
  const setSession = useAuthStore((state) => state.setSession);
  const setAuthenticating = useAuthStore((state) => state.setAuthenticating);

  return useMutation<LoginBiometriaResponse, unknown, BiometriaPayload>({
    mutationFn: (payload) => {
      setAuthenticating();
      return authApi.loginBiometria(payload);
    },
    onSuccess: (session) => {
      queryClient.clear();
      setSession(session);
    },
    onError: () => {
      useAuthStore.setState({ status: 'anonymous' });
    },
  });
}
